/**
 * MSW Overrides: Connecting Flight scenario
 *
 * Forces getBooking to return a booking with connecting flights (multiple segments)
 * so multi-segment trip rendering can be tested end-to-end in local development.
 *
 * Enable by setting ENABLE_MSW=true and MSW_OVERRIDE=true in your .env,
 * then restart the dev server.
 */

import { http, HttpResponse } from 'msw';
import { BFF_ENDPOINTS, createMockBookingResponse, createMockConnectingTrip, toMSWPattern } from '@cvo/domain';
import type { PathParams } from 'msw';

export function createConnectingFlightOverrides(baseUrl: string) {
  const sanitizedBaseUrl = baseUrl.replace(/\/$/, '');

  return [
    http.get(
      `${sanitizedBaseUrl}/${toMSWPattern(BFF_ENDPOINTS.BOOKING)}`,
      ({ params }: { params: PathParams }) => {
        const response = createMockBookingResponse({
          id: params.bookingId as string,
          outbound: createMockConnectingTrip('outbound'),
          inbound: createMockConnectingTrip('inbound'),
        });
        return HttpResponse.json(response);
      },
    ),
  ];
}
